// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".netto-price[data-v-7b7a7566]{display:inline-block;font-family:\"FrankfurterNetto\",sans-serif;min-width:90px;position:relative;text-align:center}.netto-price .price-value[data-v-7b7a7566]{background:#cf0008;color:#fff;font-weight:700;line-height:32px}.netto-price .external-price-text[data-v-7b7a7566]{padding:0 2px}.netto-marketing-hint[data-v-7b7a7566]{border-radius:100px;font-size:13px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
